import { authHeader } from '../utils/auth-header';
import apis from '../config/api';
import axios from "axios";



export const userService = {
    login,
    getUser,
    logout,
    createUser,
    updateUser
};

function login(username, password,accountId) {
    return axios.post(`${apis.user}/login`, {
        Email: username,
        Password: password,
        PartyId:accountId
    },{headers:authHeader()});
}

function getUser() {
    return axios.get(`${apis.user}`, { headers: authHeader() });
}

function logout() {
    let authHeaders = authHeader();
    if (Object.keys(authHeaders).length) {
        axios.post(`${apis.user}/logout`, {}, { headers: authHeaders});
    }
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function createUser(user){
    return axios.post(`${apis.user}/NewUser`, user,{headers:authHeader()});
}

function updateUser(user){
    console.log('updateUser()');
    console.log('user, ', user);
    return axios.put(`${apis.user}/UpdateUser`, user,{headers:authHeader()});
}


// WEBPACK FOOTER //
// ./src/services/userService.js